import script from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"

import "./AtomButton.vue?vue&type=style&index=0&id=1d2efd56&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2efd56"]])

export default __exports__